SetGameResult = (score) => {
  const element = document.getElementById("GameResult");
  if (element) {
    element.value = score;
    const event = new CustomEvent("ionChange", {
      detail: { value: score },
      bubbles: true,
      composed: true,
    });
    element.dispatchEvent(event);
  }
};

ExitGame = (score) => {
  const element = document.getElementById("ExitGame");
  if (element) {
    element.value = score;
    const event = new CustomEvent("ionChange", {
      detail: { value: score },
      bubbles: true,
      composed: true,
    });
    element.dispatchEvent(event);
  }
};

SendGameEvent = (score) => {
  const element = document.getElementById("GameEvent");
  if (element) {
    element.value = score;
    const event = new CustomEvent("ionChange", {
      detail: { value: score },
      bubbles: true,
      composed: true,
    });
    element.dispatchEvent(event);
  }
};

StartGame = () => {
  const element = document.getElementById("StartGame");
  if (element) {
    const startValue = new Date().getTime().toString();
    element.value = startValue;
    const event = new CustomEvent("ionChange", {
      detail: { value: startValue },
      bubbles: true,
      composed: true,
    });
    element.dispatchEvent(event);
  }
};
